<app-mobile-menu></app-mobile-menu>
<div class="kingster-body-outer-wrapper ">
  <div class="kingster-body-wrapper clearfix  kingster-with-frame">
    <app-top-header></app-top-header>
    <app-menu></app-menu>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
  </div>
</div>
<ngx-ui-loader></ngx-ui-loader>